import { render, staticRenderFns } from "./handling.vue?vue&type=template&id=e9bed18a&scoped=true"
import script from "./handling.vue?vue&type=script&lang=js"
export * from "./handling.vue?vue&type=script&lang=js"
import style0 from "./handling.vue?vue&type=style&index=0&id=e9bed18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bed18a",
  null
  
)

export default component.exports